module.exports = __webpack_public_path__ + "img/img8.510b7ac3.png";